import { render } from "./BackPanel.vue?vue&type=template&id=659efd08"
import script from "./BackPanel.vue?vue&type=script&lang=js"
export * from "./BackPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__